// @flow
import * as React from 'react';
import { useEffect, useRef } from 'react';

import '../../../static/scss/components/ui/collapsibleContainer.scss';

const collapse = (ref, height, animationFrameRef) => {
  const element = ref.current;

  // eslint-disable-next-line no-param-reassign
  animationFrameRef.current = requestAnimationFrame(() => {
    element.style.height = `${height}px`;

    // eslint-disable-next-line no-param-reassign
    animationFrameRef.current = requestAnimationFrame(() => {
      element.style.height = '0px';
    });
  });
};

const expand = (ref, height, initialVisible) => {
  const element = ref.current;
  element.style.height = `${height}px`;

  const setInitialHeight = () => {
    element.style.height = 'auto';
  };

  if (initialVisible.current) {
    setInitialHeight();
    // eslint-disable-next-line no-param-reassign
    initialVisible.current = false;
  }

  element.addEventListener('transitionend', setInitialHeight);
  element.removeEventListener('transitionend', setInitialHeight);
};

type Props = {
  collapsed: boolean,
  children: React.Node,
  initiallyVisible?: boolean
};

const CollapsibleContainer = ({
  collapsed,
  children,
  initiallyVisible = false
}: Props) => {
  const animationFrameRef = useRef(null);

  const el = useRef(null);
  const initialVisibleRef = useRef(initiallyVisible);

  useEffect(
    () => {
      if (!el.current) return;

      const height = el.current.scrollHeight;
      window.cancelAnimationFrame(animationFrameRef.current);

      if (collapsed) {
        expand(el, height, initialVisibleRef);
      } else {
        collapse(el, height, animationFrameRef);
      }
    },
    [collapsed, el, animationFrameRef]
  );

  return (
    <div>
      <div className="c-collapsibleContainer">
        <div ref={el} className="section">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CollapsibleContainer;
